import { PdModalMediaOptions } from '@peckadesign/pd-modal/dist/contentLoaders/MediaGalleryContentLoader'

// Only videos are opened in the gallery, so the default image wording of the pager would be misleading.
export const mediaGalleryContentLoaderOptions: Partial<PdModalMediaOptions> = {
	i18n: {
		cs: { prev: 'Předchozí video', next: 'Následující video', showImage: 'Zobrazit video', imageOf: 'z' },
		sk: { prev: 'Predchádzajúce video', next: 'Nasledujúce video', showImage: 'Zobraziť video', imageOf: 'z' },
		en: { prev: 'Previous video', next: 'Next video', showImage: 'Show video', imageOf: 'of' }
	}
}
